import { getDemoWidgetValue } from 'calling-integration-sdk-support/external-provider/operators/getDemoWidgetCallingProvider';
import { getExtensionsWidgetValue } from 'calling-integration-sdk-support/external-provider/operators/getExtensionsCallingProvider';
export const getProviderFromLocalStorage = () => {
  const demoWidgetValue = getDemoWidgetValue();
  const extensionsWidgetValue = getExtensionsWidgetValue();
  return demoWidgetValue || extensionsWidgetValue;
};